<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Documents" />
        <div class="container-fluid">
            <div class="col-xxl-12">
                <div class="card">
                    <!-- <div class="card-header">
                        <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                            data-original-title="test" data-bs-target="#workpermitAdd">Documents</button>
                    </div> -->
                    <div class="card-body">
                        <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
                            <li class="nav-item"><a class="nav-link active nav-border pt-0 txt-danger nav-danger"
                                    id="all-gatepass-tab" data-bs-toggle="tab" href="#all-gatepass" role="tab"
                                    aria-controls="all-gatepass" aria-selected="true"><i
                                        class="icofont icofont-man-in-glasses"></i>All</a></li>                          
                        </ul>
                        <div class="tab-content" id="topline-tabContent">
                            <div class="tab-pane fade show active" id="all-gatepass" role="tabpanel"
                                aria-labelledby="all-gatepass-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">All Documents:</h6>
                                        <button class="btn btn-primary text-white" v-if="reschedule.length > 0"
                                            data-bs-toggle="modal" data-original-title="test"
                                            data-bs-target="#rescheduleHere">Reschedule</button>
                                    </div>
                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display datatable" id="basic-1">
                                                <thead>
                                                    <tr>
                                                        <!-- <th></th> -->
                                                        <th>SR</th>
                                                        <th>Register Date</th>
                                                        <th>Document Name</th>
                                                        <th>Document</th>
                                                        <th>Delete</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in  workpermitdetails" :key="item.workpermitid">
                                                        <!-- <td><input type="checkbox" @click="() => { selectUsers(item.id) }"
                                                                :value="item.id" /></td> -->
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ item.iddate }}</td>
                                                    
                                                        <td>{{ item.documentid }} </td>
                                                        <td>
                                                            <a :href="this.$hostname + 'writable/uploads/workpermit/' + item.documentpath" target="_blank">View</a>
                                                          </td> 
                                                          <td>
                                                            <button @click="deleteitem(item.id,item.workpermitid)" class="btn-primary">Delete</button>
                                                          </td>
                                                          
                                                          
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ModalsPart v-if="!['login'].includes($route.name)" @getGatePassData="updateData" />
</template>
<style scoped>
.avatar {
    width: 50px;
    height: 50px;
    border-radius: 30px;
}

.badge_sm {
    padding: 2px 5px;
    border-radius: 10px;
    font-size: smaller;
    color: white;
}
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import GatePass from '@/components/GatepassPrint.vue';
import Swal from 'sweetalert2';
import axios from 'axios';
import QRCode from 'qrcode';

export default {
    name: 'CreateGatepass',
    components: {
        PageTitle, ModalsPart, GatePass
    }, mounted() {
        if(this.$route.query.id){
        this.getBasics(this.$route.query.id);
        }else{
        this.getBasics();
        }
        

    }, data() {
        return {
            reschedule: [],
            user: [],
            workpermitdetails:[],
            sd:0
        }
    },
    methods: {
        getBasics(id="",) {
            var self = this;
            axios.post('getworkpermitdetails',{id:id}).then(function (response) {
                self.workpermitdetails = response.data.workpermitdetails;
                window.scrollTo(0, 0);
            }).then(() => {
                $(".datatable").DataTable({
                    dom: 'Bfrtip',
                    buttons: ['excel', 'pdf'],
                    "paging": true,
                    "ordering": true,
                    "autoWidth": false
                });
            });


        },


        deleteitem(id,workpermitid) {
        var self = this;
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you really want to delete this?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
        if (result.isConfirmed) {
            axios.post('deletedocumentsdetails', { id: id ,workpermitid: workpermitid }).then(function (response) {
                self.workpermitdetails = response.data.workpermitdetails;
              
                window.scrollTo(0, 0);
                Swal.fire(
                    'Deleted!',
                    'The item has been deleted.',
                    'success'
                );
            });
        }
    });
},



    





     
          
    }
}
</script>

<style>
    td {
  pointer-events: auto;
}
</style>
